import { gql, useQuery } from '@apollo/client'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import React from 'react'
import { GenericError } from '../../error-pages'
import Spinner from '../../loading/components/Spinner'
import AlertCommentInput from './AlertCommentInput'
import AlertCommentList from './AlertCommentList'

const query = gql`
  query AlertCommentsQuery($alertID: Int!) {
    alert(id: $alertID) {
      id
      comments {
        id
        message
        createdAt
        author {
          id
          name
        }
      }
    }
  }
`

export default function AlertComments({
  alertID,
}: {
  alertID: number
}): React.JSX.Element {
  const { data, loading, error, refetch } = useQuery(query, {
    variables: { alertID },
  })

  if (loading && !data) return <Spinner />
  if (error) return <GenericError error={error.message} />

  return (
    <Grid item xs={12} className='cardContainer'>
      <Card sx={{ width: '100%' }}>
        <CardContent>
          <Typography component='h3' variant='h5'>
            Comments
          </Typography>
        </CardContent>
        <CardContent>
          <AlertCommentList comments={data?.alert?.comments || []} />
          <AlertCommentInput alertID={alertID} onCommentAdded={refetch} />
        </CardContent>
      </Card>
    </Grid>
  )
}
